import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const UserContext = createContext({});

const UserProvider = ({ site, userSlug, children }) => {
  const [user, setUser] = useState(null);
  const userPaths = useMemo(() => ({
    NRD: window.MyAD.nimrod_domain,
    Search: window.MyAD.search_domain,
    MyAD: `/${site}`,
    MyADWithUser: `/${site}/${userSlug}`,
    audio: `/${site}/${userSlug}/audio`,
    maps: `/${site}/${userSlug}/maps`
  }), [site, userSlug]);

  useEffect(() => {
    const syncUser = () => setUser(window.AD?.CurrentUser || null);

    if (window.MyAD?.userLoaded) {
      syncUser();
    }

    document.addEventListener("myad:user-loaded", syncUser);

    return () => {
      document.removeEventListener("myad:user-loaded", syncUser);
    };
  }, []);

  return (
    <UserContext.Provider value={{ site, userSlug, user, userPaths }}>
      {children}
    </UserContext.Provider>
  );
};

export function useUser () {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within an UserProvider");
  }
  return context;
}

export default UserProvider;
